// React and related imports
import React from 'react';

// Flowbite Components
import { Table } from 'flowbite-react';

// Custom Components
import { TableHead } from '../../components/Table/Table';
import { QuestionsTableBody } from './QuestionsTableBody';

// i18n translation
import { useTranslation } from 'react-i18next';

// Interfaces
import { IQuestion } from '../../common/interfaces/Question.interface';

interface QuestionsTableProps {
  questionsList: IQuestion[];
  handleEditQuestion: (question: IQuestion) => void;
}

export const QuestionsTable: React.FC<QuestionsTableProps> = ({
  questionsList,
  handleEditQuestion,
}) => {
  const { t } = useTranslation();

  const columnHeadLabels = [
    { id: 'question', label: t('questions.question') },
    { id: 'status', label: t('content.status') },
    { id: 'numberOfAnswers', label: t('questions.numberOfAnswers') },
    { id: 'correctAnswer', label: t('questions.correctAnswer') },
    { id: 'actions', label: '' },
  ];

  return (
    <Table>
      <TableHead columns={columnHeadLabels} withSortingIcon />
      <QuestionsTableBody
        questionsList={questionsList}
        handleEditQuestion={handleEditQuestion}
      />
    </Table>
  );
};
